export type ExactSlideshowStore = {
  [key: string]: unknown;
  id: string;
  cName: string;
};

export type SlideshowDispensaryResult = {
  dispensary?: { [key: string]: unknown; id?: unknown; cName?: unknown } | null;
  dispensaryId?: unknown;
};

/** Rejects useDispensary's sibling fallback unless it matches the identity the renderer requested. */
export function exactSlideshowStore(result: SlideshowDispensaryResult): ExactSlideshowStore | null {
  const requestedIdentity =
    typeof result.dispensaryId === 'string' || typeof result.dispensaryId === 'number'
      ? String(result.dispensaryId).trim()
      : '';
  const id =
    typeof result.dispensary?.id === 'string' || typeof result.dispensary?.id === 'number'
      ? String(result.dispensary.id).trim()
      : '';
  const cName = typeof result.dispensary?.cName === 'string' ? result.dispensary.cName.trim() : '';

  if (!requestedIdentity || !id || !cName) return null;
  if (requestedIdentity !== id && requestedIdentity !== cName) return null;
  return { ...result.dispensary, id, cName };
}
